import React from "react";
import { NavLink } from "react-router-dom";

const BusinessCreditProfileSubmitted = (props: any) => {
    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <em className="las la-check"></em>
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">Your Form has been submitted</h2>
                        </div>
                    </div>
                </div>
                <div className="box-content">
                    <p>We&apos;ll take it from here, so you can focus on your business.</p>
                    <p>
                        Verifying your Business Credit Profile usually takes about{" "}
                        {props.creditProvider != null && props.creditProvider === "DUNBRADSTREET" ? "30" : "5-10"} business days. Look out for regular status
                        updates from us in your inbox.
                    </p>

                    <div className="margin-top-xl"></div>

                    {props.selectedTab === "0" && (
                        <NavLink to="/dashboard" className="btn-default btn-primary btn-min-width">
                            <span className="btn-text">Close</span>
                        </NavLink>
                    )}

                    {props.selectedTab === "1" && (
                        <NavLink to="/credit/score" className="btn-default btn-primary btn-min-width">
                            <span className="btn-text">Close</span>
                        </NavLink>
                    )}

                    {props.selectedTab === "2" && (
                        <NavLink to="/credit/report" className="btn-default btn-primary btn-min-width">
                            <span className="btn-text">Close</span>
                        </NavLink>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default BusinessCreditProfileSubmitted;
